import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IDialogError } from '../interfaces/error.interface';

@Injectable({
    providedIn: 'root'
})
export class DisplayErrorService {
    private dataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    setData (err: IDialogError) {
        let errorMessage = 'weCouldnotProcessYourRequest';
        let header = 'cannotProcessRequestPleaseRetryAfterSometime';
        if (err?.error?.message) {
            errorMessage = err?.error?.message;
        }
        if(err?.error?.header){
            header = err?.error?.header;
        }
        this.dataSubject.next({
            message: errorMessage,
            header,
            type: err.error.type
        });
    }

    getData (): Observable<any> {
        return this.dataSubject.asObservable();
    }
}
